import type { AnvilToolHandlerFunction } from '../handler-function-type'
import type {
  ClientToolCall,
  AnvilToolCall,
  AnvilToolOutput,
} from '@anvil/common/tools/list'

type ToolName = 'list_directory'
export const handleListDirectory = (async (params: {
  previousToolCallFinished: Promise<void>
  toolCall: AnvilToolCall<ToolName>
  requestClientToolCall: (
    toolCall: ClientToolCall<ToolName>,
  ) => Promise<AnvilToolOutput<ToolName>>
}): Promise<{
  output: AnvilToolOutput<ToolName>
}> => {
  const { previousToolCallFinished, toolCall, requestClientToolCall } = params

  await previousToolCallFinished
  return { output: await requestClientToolCall(toolCall) }
}) satisfies AnvilToolHandlerFunction<ToolName>
